import type { InputProps } from 'antd';
import InputMask from 'react-input-mask';

import { Input } from './Input';

export type DateTextInputProps = InputProps & {
  maskFormat?: string;
};

export const DateTextInput = (props: DateTextInputProps): JSX.Element => {
  return (
    <InputMask
      mask={props.maskFormat || '99/99/9999'}
      value={props.value}
      onChange={props.onChange}
      placeholder={props.placeholder}
      maskChar={null}
      disabled={props.disabled ?? undefined}
    >
      {(inputProps) => (
        <Input
          disabled={props.disabled ?? undefined}
          status={props.status}
          {...inputProps}
        />
      )}
    </InputMask>
  );
};
